export default __webpack_public_path__ + "static/media/strategyImg2.75877a0f.jpg";